import { Footer } from '../../components/Footer/Footer';
import { AppShell } from '../../components/AppShell/AppShell';
import { CourseBox } from '../../components/CourseBox/CourseBox';
import { HighlightedCard } from '../../components/HighlightedCard/HighlightedCard';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { useEffect } from 'react';
import styles from './Courses.module.scss';
import { useParams } from 'react-router-dom';

const CoursesComponent = () => {
  const { t } = useTranslation();
  const { courses, getCourses, userCompanyData } = useFirebase();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    getCourses(id).catch(console.error);
  }, []);

  if (!courses) return <FullscreenLoader />;

  return (
    <AppShell>
      <div className={'d-flex flex-column flex-grow-1'}>
      <Title>{t('labels.corsi')}</Title>

      <Container>
        {!courses.length && (
          <div className={'my-5'}>
            <h1 className={'text-page-title text-center'}>{t('courses.labels.noCorsi')}</h1>
          </div>
        )}

        {/* CORSO ASO */}
        {!!courses.length && !id && (
          <>
            <h1 className={'text-page-title text-center'}>{t('courses.labels.corsiDisponibili')}</h1>
            <HighlightedCard className="p-3">
              <p>{t('courses.labels.corsiDisponibiliDescrizione')}</p>
              <p>{t('courses.labels.corsiDisponibiliDescrizione2')}</p>
              <p className={'mb-0'}>{t('courses.labels.corsiDisponibiliDescrizione3')}</p>
            </HighlightedCard>
            {courses.map((course, i) => (
              <CourseBox key={i.toString()} course={course} />
            ))}
          </>
        )}

        {/* CORSO AZIENDALE */}
        {!!courses.length && id && (
          <>
            <div
              style={{
                height: '150px',
                border: '3px solid white',
                borderRadius: '8px',
                backgroundImage: `url(${userCompanyData.logoUrl}})`,
              }}
               className={`display-4 mb-5 text-center d-flex align-items-center justify-content-center ${styles.tootorBg}`}
            >
               <div className={styles.titleCard}>{userCompanyData.name}</div>
            </div>
            {courses.map((course, i) => (
              <CourseBox key={i.toString()} course={course} />
            ))}
          </>
        )}
      </Container>

      <Footer />
      </div>
    </AppShell>
  );
};

export default CoursesComponent;
